<div class="rs-padding-bottom2 rs-maxh" *ngIf="tvBonusEligible" data-cy="tvBonusEligibleBox">
  <div class="panel rs-no-margin rs-bg-grey1 rs-maxh">
    <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
      {{ 'tv.bonus.title' | translate }}
    </h3>
    <p *ngIf="tvBonusDiscountText">{{ tvBonusDiscountText }}</p>
    <p *ngIf="!tvBonusDiscountText">
      {{ 'tv.bonus.discountTextOldPacks' | translate }}
    </p>
  </div>
</div>
